import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

export const shopMenu = (theme: Theme) => css`
  flex: 1 0 19.25rem;
  padding: 1.25rem 0 1rem;
  width: 19.25rem;
  height: 42.8125rem;
  display: flex;
  flex-direction: column;
  border-radius: 0 0 ${borders.radiusBase} ${borders.radiusBase};
  background-color: ${theme.system.backgroundBase};
  hr {
    margin: 0.75rem 1rem;
    width: auto;
  }
`;

export const heading = css`
  padding: 0.25rem 0;
  margin: 0 1rem 1.75rem;
  display: block;
`;

export const links = css`
  display: grid;
  grid-template-rows: repeat(18, auto);
  grid-auto-flow: column;
  grid-auto-columns: 19.25rem;
  grid-gap: 1rem;
`;
